import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKey as queryKeyGeblokkeerdeWeken } from '../../../entity/planning/hooks/useGeblokkeerdeWekenForEntity'
import { useAlerts } from '../../../theme/hooks/useAlerts'
import { cancelBijlageForEntity } from '../services/cancelBijlageForEntity'

import { queryKey as queryKeyAssignedBijlagen } from './useAssignedBijlagenForEntity'
import { queryKey as queryKeyBijlagen } from './useBijlagenForEntity'

export { useCancelBijlageForEntity }

const useCancelBijlageForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: cancelBijlageForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyBijlagen] })
      queryClient.invalidateQueries({ queryKey: [queryKeyAssignedBijlagen] })
      queryClient.invalidateQueries({ queryKey: [queryKeyGeblokkeerdeWeken] })
      successAlert('Bijlage successvol geannuleerd')
    },
  })
}
